import { __assign } from "tslib";
import { useEffect } from 'react';
import { TrackApiError, TrackApiNoResponse, TrackApiNotValid, } from './eventLoggerFunctions';
function handleApiResponse(_a) {
    var screen = _a.screen, version = _a.version, projectKey = _a.projectKey, apiError = _a.apiError, apiIsLoading = _a.apiIsLoading, apiItems = _a.apiItems, apiItemsInvalid = _a.apiItemsInvalid, isMobile = _a.isMobile, userId = _a.userId, sessionId = _a.sessionId, domainScopedSessionId = _a.domainScopedSessionId, clientId = _a.clientId, _b = _a.pageUrl, pageUrl = _b === void 0 ? '' : _b, _c = _a.eventLoggerUrl, eventLoggerUrl = _c === void 0 ? '' : _c, _d = _a.eventLoggerApiKey, eventLoggerApiKey = _d === void 0 ? '' : _d, _e = _a.isPreview, isPreview = _e === void 0 ? false : _e;
    if (apiIsLoading === true) {
        return null;
    }
    var apiTrackingBaseParameters = {
        screen: screen,
        version: version,
        projectKey: projectKey,
        isMobile: isMobile,
        userId: userId,
        sessionId: sessionId,
        domainScopedSessionId: domainScopedSessionId,
        clientId: clientId,
        pageUrl: pageUrl,
        eventLoggerUrl: eventLoggerUrl,
        eventLoggerApiKey: eventLoggerApiKey,
        isPreview: isPreview,
    };
    if (apiError) {
        return TrackApiError(__assign(__assign({}, apiTrackingBaseParameters), { error: apiError }));
    }
    if (apiItemsInvalid.length > 0) {
        return TrackApiNotValid(__assign({ data: apiItemsInvalid }, apiTrackingBaseParameters));
    }
    if (!apiItems || apiItems.length < 1) {
        return TrackApiNoResponse(__assign({}, apiTrackingBaseParameters));
    }
    return null;
}
/**
 *
 * Check the API responses and logs if SUCCESS, ERROR, NO_RESPONSE, NOT_VALID.
 */
export function useSendApiLogs(_a) {
    var screen = _a.screen, apiError = _a.apiError, apiIsLoading = _a.apiIsLoading, apiItems = _a.apiItems, apiItemsInvalid = _a.apiItemsInvalid, version = _a.version, projectKey = _a.projectKey, isMobile = _a.isMobile, userId = _a.userId, sessionId = _a.sessionId, domainScopedSessionId = _a.domainScopedSessionId, clientId = _a.clientId, _b = _a.pageUrl, pageUrl = _b === void 0 ? '' : _b, _c = _a.eventLoggerUrl, eventLoggerUrl = _c === void 0 ? '' : _c, _d = _a.eventLoggerApiKey, eventLoggerApiKey = _d === void 0 ? '' : _d, _e = _a.isPreview, isPreview = _e === void 0 ? false : _e;
    useEffect(function () {
        handleApiResponse({
            screen: screen,
            apiError: apiError,
            apiIsLoading: apiIsLoading,
            apiItems: apiItems,
            apiItemsInvalid: apiItemsInvalid,
            version: version,
            projectKey: projectKey,
            isMobile: isMobile,
            userId: userId,
            sessionId: sessionId,
            domainScopedSessionId: domainScopedSessionId,
            clientId: clientId,
            pageUrl: pageUrl,
            eventLoggerUrl: eventLoggerUrl,
            eventLoggerApiKey: eventLoggerApiKey,
            isPreview: isPreview,
        });
    }, [apiError, apiIsLoading, apiItems, apiItemsInvalid]);
}
